module.exports = __webpack_public_path__ + "img/phone-store.93a98113.webp";